import { render, staticRenderFns } from "./TyProductList.vue?vue&type=template&id=a5a8febe&scoped=true&"
import script from "./TyProductList.vue?vue&type=script&lang=js&"
export * from "./TyProductList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a8febe",
  null
  
)

export default component.exports